import { supabase } from './supabaseClient';
import { getGatewayHardwareType } from '../utils/gatewayProductLabel';

/** Published firmware releases for ESP gateways (matches ble_frontend fleet firmware list). */
export async function listFirmwareReleasesForGateway(gateway) {
  const hardwareType = getGatewayHardwareType(gateway);
  const { data, error } = await supabase
    .from('firmware_releases')
    .select('id, hardware_type, version, channel, is_published, release_notes, created_at, published_at')
    .eq('hardware_type', hardwareType)
    .eq('is_published', true)
    .order('created_at', { ascending: false })
    .limit(50);

  if (error) {
    return { success: false, error: error.message, releases: [] };
  }
  return { success: true, releases: data || [], hardwareType };
}

/**
 * Schedule OTA for one gateway (gateway_ota_targets upsert — same as ble_frontend schedule_ota).
 */
export async function scheduleGatewayOta(gateway, firmwareRelease) {
  if (!gateway?.id || !firmwareRelease?.id) {
    return { success: false, error: 'Gateway and firmware release are required' };
  }

  const row = {
    gateway_id: gateway.id,
    firmware_release_id: firmwareRelease.id,
    state: 'pending',
    requested_at: new Date().toISOString(),
    notified_at: null,
    started_at: null,
    finished_at: null,
    error: null,
    from_version: gateway.firmware_version || null,
    to_version: firmwareRelease.version || null,
  };

  const { data, error } = await supabase
    .from('gateway_ota_targets')
    .upsert(row, { onConflict: 'gateway_id' })
    .select()
    .maybeSingle();

  if (error) {
    return { success: false, error: error.message };
  }

  return {
    success: true,
    target: data,
    toVersion: firmwareRelease.version,
  };
}
